<template>
  <div class="mt-0 border-2 border-gray-300 mb-2">
      <div class="bg-white">
          <a href="#" class="tab__link p-0 block no-underline text-gray-800 flex flex-row content-center items-center w-full" @click.prevent="active = !active">
              <span class="w-6 flex-none print:hidden flex text-center pl-1 py-1" v-show="!active"><i aria-hidden="true" class="material-icons">expand_more</i></span>
              <span class="w-6 flex-none print:hidden flex text-red-800 pl-1 py-1" v-show="active"><i aria-hidden="true" class="material-icons">cancel</i></span>
              <div class="md:w-3/12 font-bold px-3 text-base py-1">{{title}}</div>
              <div class="w-1 self-stretch border-r-2 border-gray-300"></div>
              <div class="md:w-7/12 flex-1 pl-3 text-xs leading-tight py-1">{{description}}</div>
              <div class="md:w-1/12 flex-none text-center py-1"><span class="text-xxs font-bold block mb-0 uppercase text-gray-750">Score:</span> {{score}}</div>
          </a>
      </div>
      <div class="bg-white relative border-t border-gray-400 py-4 md:w-lg" v-show="active"><slot /></div>            
  </div>
</template>
}
<script>
export default {

  props: ['title', 'score', 'description'],

  data () {
  return {
      active: false,
    }
  },
}
</script>
